export { default } from './AutoLockSubsection';
